import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import {ApiClient} from "@sfs-projects/sfs-fc-api-sdk";
import webfonts from "@/store/webfonts";
import * as _ from 'lodash';

@Module({namespaced: true})
class InvoiceTemplateModule extends VuexModule {
  public styleOrigin: object = {
    Logo: {
      'text-align': 'left',
    },
    SenderAddress: {
      'text-align': 'right',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'normal',
    },
    HorizontalLineHeader: {
      'border-color': 'black',
      'display': 'block',
    },
    HorizontalLineFooter: {
      'border-color': 'black',
      'display': 'none',
    },
    DebtorAddress: {
      'text-align': 'left',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'normal',
    },
    InvoiceNumber: {
      'text-align': 'left',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'normal',
    },
    Reference: {
      'text-align': 'left',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'normal',
    },
    Date: {
      'text-align': 'left',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'normal',
    },
    Table: {
      'text-align': 'left',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'normal',
    },
    Text: {
      'text-align': 'left',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'bold',
    },
    BillingDetails: {
      'text-align': 'left',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'bold',
    },
    PaymentTerm: {
      'text-align': 'left',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'bold',
    },
    Closing: {
      'text-align': 'left',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'normal',
    },
    Footer: {
      'text-align': 'center',
      'font-size': '14px',
      'font-family': 'Roboto',
      'font-style': 'normal',
      'font-weight': 'normal',
    },
  };
  public listConfigOrigin = [
    {
      name: 'Sender address',
      type: 'SenderAddress',
      chartSet: 'Text',
      config: {
        align: 'right',
        fontStyle: 'normal',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
    {
      name: 'Horizontal line',
      type: 'HorizontalLineHeader',
      chartSet: 'Line',
      config: {
        enable: true,
        color: '#000',
      }
    },
    {
      name: 'Debtor address',
      type: 'DebtorAddress',
      chartSet: 'Text',
      config: {
        align: 'left',
        fontStyle: 'normal',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
    {
      name: 'Invoice number',
      type: 'InvoiceNumber',
      chartSet: 'Text',
      config: {
        align: 'left',
        fontStyle: 'normal',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
    {
      name: 'Reference',
      type: 'Reference',
      chartSet: 'Text',
      config: {
        align: 'left',
        fontStyle: 'normal',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
    {
      name: 'Date',
      type: 'Date',
      chartSet: 'Text',
      config: {
        align: 'left',
        fontStyle: 'normal',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
    {
      name: 'Table',
      type: 'Table',
      chartSet: 'Text',
      config: {
        align: 'left',
        fontStyle: 'normal',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
    {
      name: 'Text',
      type: 'Text',
      chartSet: 'Text',
      config: {
        align: 'left',
        fontStyle: 'bold',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
    {
      name: 'Billing details SFS',
      type: 'BillingDetails',
      chartSet: 'Text',
      config: {
        align: 'left',
        fontStyle: 'bold',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
    {
      name: 'Payment term',
      type: 'PaymentTerm',
      chartSet: 'Text',
      config: {
        align: 'left',
        fontStyle: 'bold',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
    {
      name: 'Closing',
      type: 'Closing',
      chartSet: 'Text',
      config: {
        align: 'left',
        fontStyle: 'normal',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
    {
      name: 'Horizontal line',
      type: 'HorizontalLineFooter',
      chartSet: 'Line',
      config: {
        enable: false,
        color: '#000',
      }
    },
    {
      name: 'Footer',
      type: 'Footer',
      chartSet: 'Text',
      config: {
        align: 'center',
        fontStyle: 'normal',
        fontType: 'Roboto',
        fontSize: '14',
      }
    },
  ];

  public logoConfig = {
    url: '',
    align: 'left',
  };
  public listConfig: Array<object> = _.clone(this.listConfigOrigin);
  public style: object = _.clone(this.styleOrigin);

  public payload = {
    Logo: {},
    SenderAddress: {},
    HorizontalLineHeader: {},
    DebtorAddress: {},
    InvoiceNumber: {},
    Reference: {},
    Date: {},
    Table: {},
    Text: {},
    BillingDetails: {},
    PaymentTerm: {},
    Closing: {},
    HorizontalLineFooter: {},
    Footer: {},
  }

  @Mutation
  public async handleStyle(data: object) {
    _.forEach(data, (item: any, key) => {
      if (key === 'Logo') {
        this.logoConfig = {
          url: item.Url,
          align: item.Align,
        }
        return;
      }
      const configType: any = _.find(this.listConfig, { type: key });
      if (configType && configType.chartSet === 'Text') {
        configType.config = {
          align: item.Align,
          fontSize: item.FontSize,
          fontStyle: item.FontStyle,
          fontType: item.FontType,
        }
      } else if (configType && configType.chartSet === 'Line') {
        configType.config = {
          enable: item.Enable,
          color: item.Color,
        }
      }
    });
  }

  @Mutation
  public renderCss() {
    const styleConfig: any = this.style;
    styleConfig.Logo = {
      'text-align': this.logoConfig.align,
    }
    _.forEach(this.listConfig, (configType: any) => {
      if (configType.type === 'HorizontalLineHeader' || configType.type === 'HorizontalLineFooter') {
        styleConfig[configType.type] = {
          'display': configType.config.enable ? 'block' : 'none',
          'border-color': configType.config.color,
        }
        return;
      }
      let fontStyle = configType.config.fontStyle;
      let fontWeight = 'normal';
      if (configType.config.fontStyle === 'bold') {
        fontStyle = 'normal';
        fontWeight = 'bold';
      }
      styleConfig[configType.type] = {
        'text-align': configType.config.align,
        'font-size': configType.config.fontSize + 'px',
        'font-family': configType.config.fontType,
        'font-style': fontStyle,
        'font-weight': fontWeight,
      };
    });
  }

  @Mutation
  public setDefaultListConfig() {
    this.listConfig = [
      {
        name: 'Sender address',
        type: 'SenderAddress',
        chartSet: 'Text',
        config: {
          align: 'right',
          fontStyle: 'normal',
          fontType: 'Roboto',
          fontSize: '13',
        }
      },
      {
        name: 'Horizontal line',
        type: 'HorizontalLineHeader',
        chartSet: 'Line',
        config: {
          enable: true,
          color: '#000',
        }
      },
      {
        name: 'Debtor address',
        type: 'DebtorAddress',
        chartSet: 'Text',
        config: {
          align: 'left',
          fontStyle: 'normal',
          fontType: 'Roboto',
          fontSize: '14',
        }
      },
      {
        name: 'Invoice number',
        type: 'InvoiceNumber',
        chartSet: 'Text',
        config: {
          align: 'left',
          fontStyle: 'normal',
          fontType: 'Roboto',
          fontSize: '14',
        }
      },
      {
        name: 'Reference',
        type: 'Reference',
        chartSet: 'Text',
        config: {
          align: 'left',
          fontStyle: 'normal',
          fontType: 'Roboto',
          fontSize: '14',
        }
      },
      {
        name: 'Date',
        type: 'Date',
        chartSet: 'Text',
        config: {
          align: 'left',
          fontStyle: 'normal',
          fontType: 'Roboto',
          fontSize: '14',
        }
      },
      {
        name: 'Table',
        type: 'Table',
        chartSet: 'Text',
        config: {
          align: 'left',
          fontStyle: 'normal',
          fontType: 'Roboto',
          fontSize: '14',
        }
      },
      {
        name: 'Text',
        type: 'Text',
        chartSet: 'Text',
        config: {
          align: 'left',
          fontStyle: 'bold',
          fontType: 'Roboto',
          fontSize: '14',
        }
      },
      {
        name: 'Billing details SFS',
        type: 'BillingDetails',
        chartSet: 'Text',
        config: {
          align: 'left',
          fontStyle: 'bold',
          fontType: 'Roboto',
          fontSize: '14',
        }
      },
      {
        name: 'Payment term',
        type: 'PaymentTerm',
        chartSet: 'Text',
        config: {
          align: 'left',
          fontStyle: 'bold',
          fontType: 'Roboto',
          fontSize: '14',
        }
      },
      {
        name: 'Closing',
        type: 'Closing',
        chartSet: 'Text',
        config: {
          align: 'left',
          fontStyle: 'normal',
          fontType: 'Roboto',
          fontSize: '14',
        }
      },
      {
        name: 'Horizontal line',
        type: 'HorizontalLineFooter',
        chartSet: 'Line',
        config: {
          enable: false,
          color: '#000',
        }
      },
      {
        name: 'Footer',
        type: 'Footer',
        chartSet: 'Text',
        config: {
          align: 'center',
          fontStyle: 'normal',
          fontType: 'Roboto',
          fontSize: '14',
        }
      },
    ];
    this.logoConfig = {
      url: '',
      align: 'left',
    };
  }

  @Action
  public async getFontList(): Promise<any> {
    return webfonts;
  }

  @Action
  public async getItem(type: string) {
    return new Promise((resolve) => {
      ApiClient.get('invoice-template/' + type).then((response: any) => {
        resolve(response);
        if (response.success) {
          this.context.commit('handleStyle', response.data[0]);
        } else {
          this.context.commit('setDefaultListConfig');
        }
      });
    })
  }

  @Action
  public async saveItem(params: any): Promise<any> {
    const SenderAddress: any = _.find(this.listConfig, { type: 'SenderAddress' });
    const HorizontalLineHeader: any = _.find(this.listConfig, { type: 'HorizontalLineHeader' });
    const DebtorAddress: any = _.find(this.listConfig, { type: 'DebtorAddress' });
    const InvoiceNumber: any = _.find(this.listConfig, { type: 'InvoiceNumber' });
    const Reference: any = _.find(this.listConfig, { type: 'Reference' });
    const Date: any = _.find(this.listConfig, { type: 'Date' });
    const Table: any = _.find(this.listConfig, { type: 'Table' });
    const Text: any = _.find(this.listConfig, { type: 'Text' });
    const BillingDetails: any = _.find(this.listConfig, { type: 'BillingDetails' });
    const PaymentTerm: any = _.find(this.listConfig, { type: 'PaymentTerm' });
    const Closing: any = _.find(this.listConfig, { type: 'Closing' });
    const HorizontalLineFooter: any = _.find(this.listConfig, { type: 'HorizontalLineFooter' });
    const Footer: any = _.find(this.listConfig, { type: 'Footer' });
    const dataSend: any = {
      Type: params.key,
      Name: params.name,
      Logo: {
        Url: this.logoConfig.url,
        Align: this.logoConfig.align,
      },
      SenderAddress: {
        Align: SenderAddress.config.align,
        FontType: SenderAddress.config.fontType,
        FontStyle: SenderAddress.config.fontStyle,
        FontSize: SenderAddress.config.fontSize,
      },
      HorizontalLineHeader: {
        Enable: HorizontalLineHeader.config.enable,
        Color: HorizontalLineHeader.config.color,
      },
      DebtorAddress: {
        Align: DebtorAddress.config.align,
        FontType: DebtorAddress.config.fontType,
        FontStyle: DebtorAddress.config.fontStyle,
        FontSize: DebtorAddress.config.fontSize,
      },
      InvoiceNumber: {
        Align: InvoiceNumber.config.align,
        FontType: InvoiceNumber.config.fontType,
        FontStyle: InvoiceNumber.config.fontStyle,
        FontSize: InvoiceNumber.config.fontSize,
      },
      Reference: {
        Align: Reference.config.align,
        FontType: Reference.config.fontType,
        FontStyle: Reference.config.fontStyle,
        FontSize: Reference.config.fontSize,
      },
      Date: {
        Align: Date.config.align,
        FontType: Date.config.fontType,
        FontStyle: Date.config.fontStyle,
        FontSize: Date.config.fontSize,
      },
      Table: {
        Align: Table.config.align,
        FontType: Table.config.fontType,
        FontStyle: Table.config.fontStyle,
        FontSize: Table.config.fontSize,
      },
      Text: {
        Align: Text.config.align,
        FontType: Text.config.fontType,
        FontStyle: Text.config.fontStyle,
        FontSize: Text.config.fontSize,
      },
      BillingDetails: {
        Align: BillingDetails.config.align,
        FontType: BillingDetails.config.fontType,
        FontStyle: BillingDetails.config.fontStyle,
        FontSize: BillingDetails.config.fontSize,
      },
      PaymentTerm: {
        Align: PaymentTerm.config.align,
        FontType: PaymentTerm.config.fontType,
        FontStyle: PaymentTerm.config.fontStyle,
        FontSize: PaymentTerm.config.fontSize,
      },
      Closing: {
        Align: Closing.config.align,
        FontType: Closing.config.fontType,
        FontStyle: Closing.config.fontStyle,
        FontSize: Closing.config.fontSize,
      },
      HorizontalLineFooter: {
        Enable: HorizontalLineFooter.config.enable,
        Color: HorizontalLineFooter.config.color,
      },
      Footer: {
        Align: Footer.config.align,
        FontType: Footer.config.fontType,
        FontStyle: Footer.config.fontStyle,
        FontSize: Footer.config.fontSize,
      },
    }
    if (params.addNew) {
      return new Promise((resolve) => {
        ApiClient.post('invoice-template', dataSend).then((response: any) => {
          resolve(response);
        });
      })
    } else {
      return new Promise((resolve) => {
        ApiClient.put('invoice-template/' + params.key, dataSend).then((response: any) => {
          resolve(response);
        });
      })
    }
  }

  @Action
  public async uploadLogo(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    return new Promise((resolve) => {
      ApiClient.post('file/upload',
        formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response: any) => {
          resolve(response);
      });
    })
  }
}

export default InvoiceTemplateModule